<template>
  <div >
  <div id="app" @dragover.prevent @drop="handleDrop" :class="{ 'drag-over': isDragOver }">
    <div>
      <div class="title"></div>
    <h1 v-if="!uploadStatus">UPLOAD<span> YOUR ANIMATION</span></h1>
    <h1 v-if="uploadStatus">CONGRATULATIONS!!!!!</h1>
    <input type="file" @change="handleFileUpload" accept="video/*" ref="fileInput" style="display: none;" />
    <div v-if="!uploading && !uploadStatus" class="upload-area" @click="triggerFileInput">
      <p v-if="!selectedFile">Drag & Drop your video here or click to select</p>
      <p v-else>Selected File: {{ selectedFile.name }}</p>
    </div>
    <div v-if="uploading || uploadStatus" class="upload-area">
      <p v-if="uploading">Uploading: {{ uploadProgress }}% Complete</p>
      <p v-if="uploading">Estimated Time Remaining: {{ timeRemaining }}</p>
      <p v-if="uploadStatus">VIDEO SUBMITTED</p>
    </div>
    <button v-show="selectedFile && (!uploading && !uploadStatus)" @click="uploadVideo" :disabled="uploading">Upload</button>
    
   
  </div>
  </div>
  <div class="logo"></div>
  </div>
</template>

<script>
import { storage, ref, uploadBytesResumable, getDownloadURL } from './firebase';

export default {
  name: 'App',
  data() {
    return {
      selectedFile: null,
      uploading: false,
      uploadStatus: '',
      uploadProgress: 0,
      startTime: null,
      elapsedTime: 0,
      timeRemaining: '',
      isDragOver: false,
    };
  },
  methods: {
    handleFileUpload(event) {
      this.selectedFile = event.target.files[0];
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleDrop(event) {
      event.preventDefault();
      this.isDragOver = false;
      if (event.dataTransfer.files.length > 0) {
        this.selectedFile = event.dataTransfer.files[0];
      }
    },
    async uploadVideo() {
      if (!this.selectedFile) {
        this.uploadStatus = 'Please select a video file first.';
        return;
      }

      const storageRef = ref(storage, `videos/${this.selectedFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, this.selectedFile);

      this.uploading = true;
      this.uploadProgress = 0;
      this.startTime = Date.now();

      uploadTask.on('state_changed', 
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.uploadProgress = Math.round(progress);
          this.elapsedTime = (Date.now() - this.startTime) / 1000; // in seconds
          const speed = snapshot.bytesTransferred / this.elapsedTime; // bytes per second
          const remainingBytes = snapshot.totalBytes - snapshot.bytesTransferred;
          const remainingTime = remainingBytes / speed; // in seconds
          this.timeRemaining = this.formatTime(remainingTime);
        }, 
        (error) => {
          this.uploadStatus = `Upload failed: ${error.message}`;
          this.uploading = false;
        }, 
        async () => {
          try {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            //this.uploadStatus = `Upload successful: ${downloadURL}`;
            this.uploadStatus = `Upload successful`;
          } catch (error) {
            this.uploadStatus = `Failed to retrieve download URL: ${error.message}`;
          } finally {
            this.uploading = false;
          }
        }
      );
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${minutes}m ${secs}s`;
    }
  },
};
</script>

<style>
body{
  background-color:#01A5CB;
  color:#EDD159;
}
#app {
  text-align: center;
  margin-top: 50px;
  text-transform: uppercase;
  font-family: Arial;
  display:flex;
  width:100%;
  justify-content: center;
}

.upload-area {
  text-align: center;
  border: 2px dashed #EDD159;
  padding: 20px;
  border-radius: 10px;
  max-width:400px;
  cursor: pointer;
  margin:auto;
  margin-bottom: 10px;
}

.upload-area.drag-over {
  border-color: #00f;
}

.drag-over {
  border-color: #00f;
}
.title{
  width:1000px;
  height:190px;
  max-width:100vw;
  min-height:100px;
  /* background-image: url(../src/assets/title.png); */
   background-image: url('../src/assets/Student competition header small.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 0% 100%;
}
.logo{
  
  bottom:0px;
  width:100%;
  min-height:100px;
  /* background-image: url(../src/assets/logo.png); */
  /* background-image: url('../src/assets/Student competition header small.png'); */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 100%;
}
button{
  cursor:pointer;
  background-color:#EDD159;
  color:#fff;
  font-size:16px;
  font-weight:600;
  text-transform: uppercase;
  border-radius:5px;
  border:2px solid #fff;
  margin-bottom:10px;
}
</style>
